import { ref } from 'vue';

const defaultStyle = 'background-image: revert-layer; background-color: revert-layer;';
const style = ref(defaultStyle);
const blurClass = ref('');

function changeBackground(url?: string, color?: string, repeat?: boolean, blur?: boolean) {
    const styles = [];
    if (url) {
        styles.push(`background-image: url(${url})`);
    }
    if (color) {
        styles.push(`background-color: ${color}`);
    }
    if (repeat) {
        styles.push('background-repeat: repeat; background-size: auto');
    }
    blurClass.value = blur ? 'blur-area' : '';
    style.value = styles.join('; ');
}

function resetBackground() {
    style.value = defaultStyle;
    blurClass.value = '';
}

export function useBackground() {
    return {
        style,
        blurClass,
        changeBackground,
        resetBackground,
    };
}
